<template>
  <div>
    <v-data-table
      :headers="customerRepairBomItemDataTableHeaders"
      :items="customerRepairBomItems"
      class="elevation-1 ma-5 "
      :search="searchCustomerRepairBomItem"
      :loading-text="$t('common_get_data')"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      :footer-props="{
        'items-per-page-options': [30, 50, 100],
        'items-per-page-text': $t('item_rows_per_page'),
      }"
      :header-props="headerProps"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t('customer_repair_item_toolbar_title') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="searchCustomerRepairBomItem"
            append-icon="mdi-magnify"
            :label="$t('customer_repair_item_search_label')"
            single-line
            hide-details
            clearable
          ></v-text-field>
          <v-btn
            v-if="viewName === 'update-many'"
            color="primary"
            :disabled="isAllTextFieldDisable"
            class="ml-5"
            @click="isShowEditCustomerRepairBomItemDialog = true"
          >
            {{ $t('common_new') }}
          </v-btn>
          <v-dialog v-model="isShowEditCustomerRepairBomItemDialog" fullscreen persistent>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ $t('common_edit') }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <ValidationObserver ref="repairItem">
                    <v-row v-if="viewName !== 'update-many'">
                      <v-col cols="12" sm="6" md="4" lg="4" xl="4">
                        <v-select
                          v-model="editedCustomerRepairBomItem.OriginalType"
                          :disabled="isAllTextFieldDisable"
                          item-value="Type"
                          item-text="Name"
                          :items="originalTypeList"
                          @change="changeOriginalType"
                          label="預設來源"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <ValidationProvider
                          name="Bom名稱"
                          rules="required"
                          v-slot="{ errors }"
                          v-if="editedCustomerRepairBomItemIndex === -1"
                        >
                          <v-autocomplete
                            :items="bomList"
                            item-text="Name"
                            item-value="Id"
                            return-object
                            v-model="selectedBom"
                            @change="setEditedCustomerRepairBomItem"
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              Bom名稱
                            </template>
                            <template v-slot:item="data">
                              <template>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    {{ data.item.Name }}
                                  </v-list-item-title>
                                  <v-list-item-subtitle>
                                    {{ data.item.Describe }}
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                            </template>
                          </v-autocomplete>
                        </ValidationProvider>
                        <ValidationProvider
                          name="BOM名稱"
                          rules="required"
                          v-slot="{ errors }"
                          v-else
                        >
                          <v-text-field
                            v-model="editedCustomerRepairBomItem.BomName"
                            disabled
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              BOM名稱
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <v-text-field
                          v-model="editedCustomerRepairBomItem.BomDescribe"
                          disabled
                          label="BOM描述"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <ValidationProvider
                          :name="$t('customer_repair_item_new_number')"
                          rules="required"
                          v-slot="{ errors }"
                          v-if="editedCustomerRepairBomItemIndex === -1"
                        >
                          <v-autocomplete
                            v-model="selectedItem"
                            :items="bomItemList"
                            item-text="Number"
                            item-value="Id"
                            return-object
                            @change="changeCustomerRepairBomItem"
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('customer_repair_item_new_number') }}
                            </template>
                            <template v-slot:item="data">
                              <template>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    {{ data.item.Number }}
                                  </v-list-item-title>
                                  <v-list-item-subtitle>
                                    {{ data.item.Name }}
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                            </template>
                          </v-autocomplete>
                        </ValidationProvider>
                        <v-text-field
                          v-else
                          v-model="editedCustomerRepairBomItem.Number"
                          :label="$t('customer_repair_item_new_number')"
                          disabled
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <ValidationProvider
                          :name="$t('customer_repair_item_new_name')"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedCustomerRepairBomItem.Name"
                            disabled
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('customer_repair_item_new_name') }}
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <ValidationProvider
                          name="新品維修保固"
                          :rules="{ required: true, regex: /^[0-9]+$/ }"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedCustomerRepairBomItem.RepairWarrantyPeriod"
                            @keyup.enter="focusNextInput"
                            :error-messages="errors[0]"
                            :disabled="
                              editedCustomerRepairBomItem.OriginalType !== originalType.Customize
                            "
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              新品維修保固
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <ValidationProvider
                          name="新品維修價格"
                          :rules="{ required: true, regex: /^[0-9]+$/ }"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedCustomerRepairBomItem.RepairPrice"
                            @change="turnOldRepairPrice"
                            @keyup.enter="focusNextInput"
                            :error-messages="errors[0]"
                            :disabled="
                              editedCustomerRepairBomItem.OriginalType !== originalType.Customize
                            "
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              新品維修價格
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row v-if="editedCustomerRepairBomItem.OldItemId">
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <v-text-field
                          v-model="editedCustomerRepairBomItem.OldNumber"
                          :label="$t('customer_repair_item_old_number')"
                          disabled
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <v-text-field
                          v-model="editedCustomerRepairBomItem.OldName"
                          :label="$t('customer_repair_item_old_name')"
                          disabled
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row v-if="editedCustomerRepairBomItem.OldItemId">
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <ValidationProvider
                          name="良品維修保固"
                          :rules="{ regex: /^[0-9]+$/ }"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedCustomerRepairBomItem.OldRepairWarrantyPeriod"
                            label="良品維修保固"
                            @keyup.enter="focusNextInput"
                            :error-messages="errors[0]"
                            :disabled="
                              editedCustomerRepairBomItem.OriginalType !== originalType.Customize
                            "
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="6" xl="6">
                        <ValidationProvider
                          name="良品維修價格"
                          :rules="{ regex: /^[0-9]+$/ }"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="editedCustomerRepairBomItem.OldRepairPrice"
                            label="良品維修價格"
                            @keyup.enter="focusNextInput"
                            :error-messages="errors[0]"
                            :disabled="
                              editedCustomerRepairBomItem.OriginalType !== originalType.Customize
                            "
                          ></v-text-field>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <ValidationProvider name="變更原因" rules="required" v-slot="{ errors }">
                          <v-textarea
                            outlined
                            v-model="editedCustomerRepairBomItem.Reason"
                            :error-messages="errors[0]"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              變更原因
                            </template>
                          </v-textarea>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                  </ValidationObserver>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red darken-1"
                  text
                  @click="closeEditedCustomerRepairBomItem"
                  :disabled="isAllTextFieldDisable"
                >
                  {{ $t('common_cancel') }}
                </v-btn>
                <v-btn color="green darken-1" text @click="addEditedCustomerRepairBomItem">
                  {{ $t('common_confirm') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <delete-dialog
            :isAllTextFieldDisable="isAllTextFieldDisable"
            :isLoadingSaveBtn="isLoadingSaveBtn"
            :isShowDeleteDialog="isShowDeleteCustomerRepairBomItemDialog"
            :deleteMessage="'item_group_delete_dialog_message'"
            @closeDelete="closeCustomerRepairBomItem"
            @confirmDelete="confirmDeleteCustomerRepairBomItem"
          />
        </v-toolbar>
      </template>
      <template v-slot:[`item.Edit`]="{ item }">
        <v-btn
          icon
          @click="isShowEditCustomerRepairBomItemDialogBtn(item)"
          :disabled="isAllTextFieldDisable"
        >
          <v-icon small>
            mdi-pencil
          </v-icon>
        </v-btn>
        <v-btn
          icon
          @click="isShowDeleteCustomerRepairBomItemDialogBtn(item)"
          :disabled="isAllTextFieldDisable"
        >
          <v-icon small>
            mdi-delete
          </v-icon>
        </v-btn>
      </template>
      <template v-slot:[`item.OldRepairPrice`]="{ item }">
        {{ appearPrice(item.OldRepairPrice) }}
      </template>
      <template v-slot:[`item.OldWarrantyPeriod`]="{ item }">
        {{ appearWarrantyPeriod(item.OldWarrantyPeriod) }}
      </template>
      <template v-slot:[`item.OriginalType`]="{ item }">
        {{ convertOriginalType(item.OriginalType) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import DeleteDialog from '@/components/DeleteDialog.vue'
import { HttpCustomerRepair, HttpBom, HttpItem } from '@/js/http-Manager'
import { OriginalType } from '@/js/OriginalType'
export default {
  components: { DeleteDialog },
  props: {
    customerRepairBomItems: {
      type: Array
    },
    isAllTextFieldDisable: {
      type: Boolean,
      default: false
    },
    viewName: {
      type: String
    }
  },
  name: 'UpdateCustomerRepairBomItem',
  data: () => ({
    originalType: OriginalType,
    isLoadingSaveBtn: false,
    searchCustomerRepairBomItem: '',
    editedCustomerRepairBomItem: {
      BomId: '',
      BomName: '',
      BomDescribe: '',
      ItemId: '',
      Number: '',
      Name: '',
      Price: 0,
      WarrantyPeriod: 0,
      RepairPrice: 0,
      RepairWarrantyPeriod: 0,
      OldItemId: '',
      OldNumber: '',
      OldName: '',
      OldPrice: 0,
      OldWarrantyPeriod: 0,
      OldRepairPrice: 0,
      OldRepairWarrantyPeriod: 0,
      Reason: ''
    },
    defaultCustomerRepairBomItem: {
      BomId: '',
      BomName: '',
      BomDescribe: '',
      ItemId: '',
      Number: '',
      Name: '',
      Price: 0,
      WarrantyPeriod: 0,
      RepairPrice: 0,
      RepairWarrantyPeriod: 0,
      OldItemId: '',
      OldNumber: '',
      OldName: '',
      OldPrice: 0,
      OldWarrantyPeriod: 0,
      OldRepairPrice: 0,
      OldRepairWarrantyPeriod: 0,
      Reason: ''
    },
    isShowEditCustomerRepairItemDialog: false,
    isShowDeleteCustomerRepairBomItemDialog: false,
    editedCustomerRepairBomItemIndex: -1,
    isShowEditCustomerRepairBomItemDialog: false,
    originalTypeList: [],
    bomList: [],
    bomItemList: [],
    selectedBom: null,
    selectedItem: null
  }),
  async mounted () {
    await this.getOriginalTypeList()
    await this.getAllBoms()
  },
  watch: {},
  computed: {
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    },
    customerRepairBomItemDataTableHeaders () {
      return [
        { text: '預設來源', align: 'start', value: 'OriginalType' },
        { text: 'BOM名稱', align: 'start', value: 'BomName' },
        { text: 'BOM描述', align: 'start', value: 'BomDescribe' },
        { text: this.$t('customer_repair_item_new_number'), align: 'start', value: 'Number' },
        { text: this.$t('customer_repair_item_new_name'), align: 'start', value: 'Name' },
        { text: '新品維修保固期數', align: 'end', value: 'RepairWarrantyPeriod' },
        { text: '新品維修價格', align: 'end', value: 'RepairPrice' },
        { text: this.$t('customer_repair_item_old_number'), align: 'start', value: 'OldNumber' },
        { text: this.$t('customer_repair_item_old_name'), align: 'start', value: 'OldName' },
        {
          text: '良品維修保固期數',
          align: 'end',
          value: 'OldRepairWarrantyPeriod'
        },
        {
          text: '良品維修價格',
          align: 'end',
          value: 'OldRepairPrice'
        },
        { text: '變更原因', align: 'start', value: 'Reason' },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false }
      ]
    }
  },
  methods: {
    async changeCustomerRepairBomItem () {
      this.editedCustomerRepairBomItem.ItemId = this.selectedItem.Id
      this.editedCustomerRepairBomItem.OriginalType = 10
      let response = await HttpItem.GetItemById({ id: this.selectedItem.Id })
      if (response && response.status === 200) {
        let item = response.data.Data
        if (item) {
          this.editedCustomerRepairBomItem.RepairWarrantyPeriod = this.selectedItem.RepairWarrantyPeriod
          this.editedCustomerRepairBomItem.RepairPrice = this.selectedItem.RepairPrice
          this.editedCustomerRepairBomItem.Number = this.selectedItem.Number
          this.editedCustomerRepairBomItem.Name = this.selectedItem.Name
          this.editedCustomerRepairBomItem.OldItemId = this.selectedItem.OldItemId
          this.editedCustomerRepairBomItem.OldNumber = this.selectedItem.OldNumber
          this.editedCustomerRepairBomItem.OldName = this.selectedItem.OldName
          this.editedCustomerRepairBomItem.OldRepairWarrantyPeriod = this.selectedItem.OldRepairWarrantyPeriod
          this.editedCustomerRepairBomItem.OldRepairPrice = this.selectedItem.OldRepairPrice
        }
      }
      this.editedCustomerRepairBomItem = JSON.parse(
        JSON.stringify(this.editedCustomerRepairBomItem)
      )
    },
    setEditedCustomerRepairBomItem () {
      this.editedCustomerRepairBomItem = JSON.parse(
        JSON.stringify(this.defaultCustomerRepairBomItem)
      )
      this.editedCustomerRepairBomItem.BomId = this.selectedBom.Id
      this.editedCustomerRepairBomItem.BomName = this.selectedBom.Name
      this.editedCustomerRepairBomItem.BomDescribe = this.selectedBom.Describe
      this.bomItemList = this.selectedBom.BomItems
      this.editedCustomerRepairBomItem = JSON.parse(
        JSON.stringify(this.editedCustomerRepairBomItem)
      )
    },
    async getAllBoms () {
      let response = await HttpBom.GetAllBoms()
      this.bomList = response && response.status === 200 ? response.data.Data : []
    },
    async getOriginalTypeList () {
      let response = await HttpCustomerRepair.GetOriginalTypes()
      this.originalTypeList = response && response.status === 200 ? response.data.Data : []
    },
    convertOriginalType (originalType) {
      return OriginalType.getOriginalTypeName(originalType)
    },
    appearPrice (oldRepairPrice) {
      if (oldRepairPrice !== 0) {
        return oldRepairPrice
      } else {
        return ''
      }
    },
    appearWarrantyPeriod (oldWarrantyPeriod) {
      if (oldWarrantyPeriod !== 0) {
        return oldWarrantyPeriod
      } else {
        return ''
      }
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (
          form[i].type !== 'hidden' &&
          !form[i].disabled &&
          !form[i].readOnly &&
          form[i].type !== 'checkbox'
        ) {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },
    async addEditedCustomerRepairBomItem () {
      const isValid = await this.$refs.repairItem.validate()
      if (isValid) {
        this.$emit('setEditedCustomerRepairBomItemIndex', this.editedCustomerRepairBomItemIndex)
        this.$emit('addEditedCustomerRepairBomItem', this.editedCustomerRepairBomItem)
        this.closeEditedCustomerRepairBomItem()
      }
    },
    async closeEditedCustomerRepairBomItem () {
      this.isShowEditCustomerRepairBomItemDialog = false
      this.$nextTick(() => {
        this.editedCustomerRepairBomItem = JSON.parse(
          JSON.stringify(this.defaultCustomerRepairBomItem)
        )
        this.editedCustomerRepairBomItemIndex = -1
        this.selectedBom = null
        this.selectedItem = null
      })
    },
    isShowEditCustomerRepairBomItemDialogBtn (item) {
      this.editedCustomerRepairBomItemIndex = this.customerRepairBomItems.indexOf(item)
      this.editedCustomerRepairBomItem = JSON.parse(JSON.stringify(item))
      this.isShowEditCustomerRepairBomItemDialog = true
    },

    isShowDeleteCustomerRepairBomItemDialogBtn (item) {
      this.editedCustomerRepairBomItemIndex = this.customerRepairBomItems.indexOf(item)
      this.isShowDeleteCustomerRepairBomItemDialog = true
    },
    confirmDeleteCustomerRepairBomItem () {
      this.$emit('confirmDeleteCustomerRepairBomItem', this.editedCustomerRepairBomItemIndex)
      this.closeCustomerRepairBomItem()
    },

    closeCustomerRepairBomItem () {
      this.isShowDeleteCustomerRepairBomItemDialog = false
      this.$nextTick(() => {
        this.editedCustomerRepairBomItemIndex = -1
      })
    },
    turnOldRepairPrice () {
      if (this.editedCustomerRepairBomItem.OldNumber) {
        this.editedCustomerRepairBomItem.OldRepairPrice = Math.round(
          this.editedCustomerRepairBomItem.RepairPrice * 0.8
        )
      }
    },
    turnOldPrice () {
      if (this.editedCustomerRepairBomItem.OldNumber) {
        this.editedCustomerRepairBomItem.OldPrice = Math.round(
          this.editedCustomerRepairBomItem.Price * 0.8
        )
      }
    },
    async changeOriginalType () {
      if (this.editedCustomerRepairBomItem.OriginalType !== this.originalType.Customize) {
        let response = await HttpCustomerRepair.GetCustomerRepairBomItemDefault({
          customerId: this.customerId,
          originalType: this.editedCustomerRepairBomItem.OriginalType,
          bomId: this.editedCustomerRepairBomItem.BomId,
          itemId: this.editedCustomerRepairBomItem.ItemId
        })
        if (response && response.status === 200) {
          let bomItem = JSON.parse(JSON.stringify(response.data.Data))
          this.editedCustomerRepairBomItem.RepairPrice = bomItem.RepairPrice
          this.editedCustomerRepairBomItem.RepairWarrantyPeriod = bomItem.RepairWarrantyPeriod
          this.editedCustomerRepairBomItem.OldRepairPrice = bomItem.OldRepairPrice
          this.editedCustomerRepairBomItem.OldRepairWarrantyPeriod =
            bomItem.OldRepairWarrantyPeriod
          this.editedCustomerRepairBomItem = JSON.parse(
            JSON.stringify(this.editedCustomerRepairBomItem)
          )
        }
      }
    }
  }
}
</script>
